import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  Typography,
  IconButton, // Import IconButton for the zoom icons
} from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn"; // Import ZoomInIcon
import ZoomOutIcon from "@mui/icons-material/ZoomOut"; // Import ZoomOutIcon
import CloseIcon from "@mui/icons-material/Close"; // Import CloseIcon for exiting full screen
import "./TunnelOven.css";
import dayjs from "dayjs";
import Slider from "react-slick";
import { useNavigate } from "react-router";
import ProgressChart from "../../components/ProgressChart/ProgressChart";
import PieChart from "../../components/PieChart/PieChart";
import SFGBarChart from "../../components/SFGBarChart/SFGBarChart";
import DispatchStatus from "../../components/DispatchStatus/DispatchStatus";
import AverageTime from "../../components/AverageTime/AverageTime";
import ProcessParameters from "../../components/ProcessParameters/ProcessParameters";
import {
  getStatusCount,
  getClassWiseBatchStatusCount,
  getClassWiseInProgressBatchCount,
  getDayWiseBatchStatusCount,
  getClassWiseDispatchStatsCount,
  getClasswiseAverageProcessingTime,
  getSFGStoreStatusCount,
  getSystemInsights,
  getProductClassWiseCount,
} from "./services";
import MqttData from "../MqttData";
import TimeDatePicker from "../../components/TimePicker/TimePicker";
import { images } from "../../config/images";
import FloorPlan from "./FloorPlan";
import { getChartColor } from "../../config/colors";
import {
  getAdvanceAnalyticsQualityVisual,
  productiondata,
} from "../AdvanceAnalytics/services";

const TunnelOven = () => {
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [showTime, setShowTime] = useState(false);
  const [qualityVisualProduction, setQualityVisualProduction] = useState([]);
  const [isFloorPlanZoomed, setIsFloorPlanZoomed] = useState(false); // New state for zoom

  const handleToggleTime = () => {
    setShowTime(!showTime);
  };

  const [deviceData, setDeviceData] = useState({});
  const [mqttData, setMqttData] = useState([]);
  const [topic, setTopic] = useState([
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:MEP",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:LCH",
    "Hikar/machineld/A8:74:1D:10:DD:A4:PA:03:PO1",
    "Hikar/machineld/A8:74:1D:19:5F:1B:PA:01:PO2",
    "Hikar/machineld/A8:74:1D:19:5F:1B:PA:01:PO3",
    "Hikar/machineld/A8:74:1D:19:5F:1B:PA:01:PO4",
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:PO5",
    "Hikar/machineld/A8:74:1D:10:DD:A4:PA:03:PO6",
    "Hikar/machineld/A8:74:1D:10:DD:A4:PA:03:PO7",
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:PO8",
    "Hikar/machineld/A8:74:1D:19:5F:1B:PA:01:BIO",
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:CHL",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:RB1",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:RB2",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:ATC",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:ULT",
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:AC",
    "Hikar/machineld/A8:74:1D:16:B9:78:PA:04:COM",
    "Hikar/machineld/A8:74:1D:10:DD:A4:PA:03:DRY",
    "Hikar/machineld/A8:74:1D:10:DD:A4:PA:03:WM1",
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:WM2",
    "Hikar/machineld/A8:74:1D:16:B8:7C:PA:02:CHL",
  ]);
  // Initialize batchStatsData with default values and colors
  const [batchStatsData, setBatchStatsData] = useState([
    {
      title: "Total Batch",
      value: 0,
      bgColor: "#d3d3d3 !important",
      textColor: "#1a1a1a",
      borderColor: "#1a1a1a",
    },
    {
      title: "Batch In Progress",
      value: 0,
      bgColor: "#ffe0b2 !important",
      textColor: "#e65100",
      borderColor: "#e65100",
    },
    {
      title: "Batch Completed",
      value: 0,
      bgColor: "#d0f0c0 !important",
      textColor: "#388e3c",
      borderColor: "#388e3c",
    },
    {
      title: "Batch Aborted",
      value: 0,
      bgColor: "#ffebee !important",
      textColor: "#c62828",
      borderColor: "#c62828",
    },
  ]);
  const [classWiseBatchData, setClassWiseBatchData] = useState([]);
  const [inProgressBatchData, setInProgressBatchData] = useState([]);
  const [dayWiseBatchStatusData, setDayWiseBatchStatusData] = useState([]);
  const [dispatchStatusData, setDispatchStatusData] = useState([]);
  const [averageProcessingTimeData, setAverageProcessingTimeData] = useState(
    []
  );
  const [productionData, setProductionData] = useState([]);

  const [insightsData, setInsightsData] = useState([]);
  const [sfgStatusData, setSfgStatusData] = useState([]);
  const [selectedSFGType, setSelectedSFGType] = useState("class"); // New state for dropdown selection
  const totalDispatchedCountForBoxes = dispatchStatusData.reduce(
    (sum, item) => sum + item.dispatched_count,
    0
  );
  console.log("sdfsdfsd", deviceData);

  const startDateData = dayjs(startDateReFormat).format("YYYY-MM-DD HH:mm:ss");
  const endDateData = dayjs(endDateReFormat).format("YYYY-MM-DD HH:mm:ss");

  const mergedArray = mqttData ? [].concat(...Object.values(mqttData)) : [];

  // Fetch batch statistics on component mount and when dates change
  useEffect(() => {
    const fetchBatchStats = async () => {
      try {
        const response = await getStatusCount(startDateData, endDateData);
        // Create a temporary array with the fetched values, preserving initial colors
        const apiBatchStats = [
          {
            title: "Total Batch",
            value: response.data.payload.total_batch || 0,
            bgColor: "#d3d3d3 !important",
            textColor: "#1a1a1a",
            borderColor: "#1a1a1a",
          },
          {
            title: "Batch In Progress",
            value: response.data.payload.inprogress_batch || 0,
            bgColor: "#ffe0b2 !important",
            textColor: "#e65100",
            borderColor: "#e65100",
          },
          {
            title: "Batch Completed",
            value: response.data.payload.completed_batch || 0,
            bgColor: "#d0f0c0 !important",
            textColor: "#388e3c",
            borderColor: "#388e3c",
          },
          {
            title: "Batch Aborted",
            value: response.data.payload.aborted_batch || 0,
            bgColor: "#ffebee !important",
            textColor: "#c62828",
            borderColor: "#c62828",
          },
        ];
        setBatchStatsData(apiBatchStats);
      } catch (error) {
        console.error("Error fetching batch status count:", error);
        // Optionally, reset to initial state or display an error message
        // setBatchStatsData(initialBatchStats); // if you defined initialBatchStats outside
      }
    };

    const fetchClassWiseBatchStats = async () => {
      try {
        const response = await getClassWiseBatchStatusCount(
          startDateData,
          endDateData
        );
        setClassWiseBatchData(response.data.payload || []);
      } catch (error) {
        console.error("Error fetching class-wise batch status count:", error);
      }
    };

    const fetchClassWiseInProgressBatch = async () => {
      try {
        const response = await getClassWiseInProgressBatchCount(
          startDateData,
          endDateData
        );
        setInProgressBatchData(response.data.payload || []);
      } catch (error) {
        console.error(
          "Error fetching class-wise in-progress batch count:",
          error
        );
      }
    };

    const fetchDayWiseBatchStatus = async () => {
      try {
        const response = await getDayWiseBatchStatusCount(
          startDateData,
          endDateData
        );
        setDayWiseBatchStatusData(response.data.payload || []);
      } catch (error) {
        console.error("Error fetching day-wise batch status count:", error);
      }
    };

    const fetchDispatchStatus = async () => {
      try {
        const response = await getClassWiseDispatchStatsCount(
          startDateData,
          endDateData
        );
        setDispatchStatusData(response.data.payload || []);
      } catch (error) {
        console.error(
          "Error fetching class-wise dispatch status count:",
          error
        );
      }
    };

    const fetchAverageProcessingTime = async () => {
      try {
        const response = await getClasswiseAverageProcessingTime(
          startDateData,
          endDateData
        );
        setAverageProcessingTimeData(response.data.payload || []);
      } catch (error) {
        console.error(
          "Error fetching class-wise average processing time:",
          error
        );
      }
    };

    if (!isNaN(new Date(startDateData)) && !isNaN(new Date(endDateData))) {
      fetchBatchStats();
      fetchClassWiseBatchStats();
      fetchClassWiseInProgressBatch();
      fetchDayWiseBatchStatus();
      fetchDispatchStatus();
      fetchAverageProcessingTime();
      const intervalIds = [];

      // Set up intervals for periodic data fetching and store their IDs
      intervalIds.push(setInterval(fetchSFGStatusCount, 900000)); // 15 minutes
      intervalIds.push(setInterval(fetchClassWiseBatchStats, 900000));
      intervalIds.push(setInterval(fetchClassWiseInProgressBatch, 900000));
      intervalIds.push(setInterval(fetchDayWiseBatchStatus, 900000));
      intervalIds.push(setInterval(fetchDispatchStatus, 900000));
      intervalIds.push(setInterval(fetchAverageProcessingTime, 900000));

      return () => {
        intervalIds.forEach((id) => clearInterval(id));
      };
    }
  }, [startDateData, endDateData, showTime]);

  useEffect(() => {
    if (!isNaN(new Date(startDateData)) && !isNaN(new Date(endDateData))) {
      fetchSFGStatusCount(); // Initial call

      const interval = setInterval(() => {
        fetchSFGStatusCount(); // Call API every 15 min
      }, 15 * 60 * 1000); // 15 minutes in milliseconds

      return () => clearInterval(interval); // Cleanup interval on unmount
    }
  }, [startDateData, endDateData, selectedSFGType, showTime]);

  useEffect(() => {
    fetchSystemInsights(); // Initial call

    const interval = setInterval(() => {
      fetchSystemInsights(); // Call API every 15 min
    }, 15 * 60 * 1000); // 15 minutes

    return () => clearInterval(interval);
  }, []);

  const fetchSFGStatusCount = async () => {
    try {
      // Pass the selectedSFGType to the API call
      const response = await getSFGStoreStatusCount(
        startDateData,
        endDateData,
        selectedSFGType
      );
      setSfgStatusData(response.data.payload || []);
    } catch (error) {
      console.error("Error fetching SFG store status count:", error);
    }
  };
  const fetchSystemInsights = async () => {
    try {
      const response = await getSystemInsights();
      setInsightsData(response.data.human_insights || []);
    } catch (error) {
      console.error("Error fetching system insights:", error);
    }
  };

  useEffect(() => {
    if (startDateData && endDateData) {
      handleProductionData();
    }
  }, [startDateData, endDateData]);

  const handleProductionData = async () => {
    const params = {
      start_date: startDateData,
      end_date: endDateData,
    };
    try {
      const resp = await getProductClassWiseCount(params);
      if (resp.status == 200 || resp.status == 201) {
        setProductionData(resp.data.payload);
      }
    } catch (error) {
      console.log("error");
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    appendDots: (dots) => (
      <div className="custom-slick-dots-container">
        <ul className="custom-slick-dots-list"> {dots} </ul>
      </div>
    ),
    customPaging: (i) => <div className="custom-slick-dot"></div>,
  };
  const handleStartDate = (newStartDate) => {
    setStartDateReFormat(newStartDate);
  };

  const handleEndDate = (newEndDate) => {
    if (newEndDate === null || !newEndDate.isValid()) {
      setEndDateReFormat(null);
    } else {
      if (showTime) {
        setEndDateReFormat(newEndDate);
      } else {
        // Set the end date to 23:59:00 if time is not shown
        setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
      }
    }
  };

  // Handle dropdown change event
  const handleSFGTypeChange = (event) => {
    setSelectedSFGType(event.target.value);
  };

  const temperatureValue =
    mergedArray.find((e) => e.device_tag === "TEMPERATURE_1")?.tagValue ?? "-";
  const humidityValue =
    mergedArray.find((e) => e.device_tag === "HUMIDITY_1")?.tagValue ?? "-";

  useEffect(() => {
    if (startDateData && endDateData) {
      getQualityVisualProduction();
    }
  }, [startDateData, endDateData]);

  const getQualityVisualProduction = async () => {
    const params = {
      start_date: startDateData,
      end_date: endDateData,
    };

    try {
      const resp = await getAdvanceAnalyticsQualityVisual(params);
      if (resp.status == 200 || resp.status == 201) {
        const changeStructureData = Object.keys(resp.data.payload).map(
          (key) => ({
            TestName: key,
            keyValue: resp.data.payload[key],
          })
        );
        console.log(
          "changeStructureDatachangeStructureData",
          changeStructureData
        );

        setQualityVisualProduction(changeStructureData);
      }
    } catch (error) {
      console.log("handleSubmit..", error);
    }
  };
  const formatTestName = (name) => {
    if (!name) return "";
    return name
      .split("_") // split by underscore
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize first letter
      .join(" "); // join back with spaces
  };
  return (
    <Box className="page-wraper">
      {topic.length > 0 && (
        <MqttData topics={topic} setMqttTagData={setMqttData} />
      )}

      {isFloorPlanZoomed && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            zIndex: 1300, // Ensure it's above other content
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <IconButton
            onClick={() => setIsFloorPlanZoomed(false)}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              zIndex: 1301,
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "lightgray",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <FloorPlan
            isFloorPlanZoomed={isFloorPlanZoomed}
            mergedArray={mergedArray}
          />
        </Box>
      )}

      {!isFloorPlanZoomed && (
        <Grid container spacing={2}>
          {/* Left Section - Stats */}
          <Grid item xs={12} md={3}>
            <Box className="left-section">
              <Box className="pipes-container">
                <div className="insights-header pipe-header">
                  <div className="header-text">Production</div>
                </div>
                <Box className="pipes-content">
                  <Grid container spacing={2}>
                    {batchStatsData.map((item, index) => (
                      <Grid item xs={12} sm={6} md={6} key={index}>
                        <Card
                          sx={{
                            backgroundColor: item.bgColor,
                            padding: "6px 12px",
                            borderRadius: 2,
                            boxShadow: 0,
                            textAlign: "center",
                            border: `1px solid ${item.borderColor}`,
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            color="textSecondary"
                            sx={{
                              textAlign: "left",
                              fontSize: "16px",
                              fontWeight: 500,
                            }}
                            className="batchStateData"
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "bold", color: item.textColor }}
                          >
                            {item.value}
                          </Typography>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
              <Box className="products-container">
                <Box className="products-box">
                  <div className="insights-header products-header">
                    <div className="header-text">Products - Class Wise</div>
                  </div>
                  <div className="products-content">
                    <ProgressChart productData={productionData} />
                  </div>
                </Box>
              </Box>
              <Box className="scan-by-countainer">
                <Box className="scan-by-box">
                  <div className="insights-header scan-by-header">
                    <div className="header-text">Production In Progress</div>
                  </div>
                  <div className="scan-by-content">
                    <div>
                      <div className="report-text">
                        <p className="mb-0">
                          Total In Progress
                          <br />
                          <b>
                            {
                              batchStatsData.find(
                                (item) => item.title === "Batch In Progress"
                              )?.value
                            }{" "}
                            Batches
                          </b>
                        </p>
                      </div>
                      <div className="no-data-container-chart">
                        <PieChart inProgressData={inProgressBatchData} />
                      </div>
                    </div>
                  </div>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Middle Section - Map */}
          <Grid item xs={12} md={6}>
            <Box className="map-section">
              <Box
                className="map-controls-left"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ display: "flex", gap: 2 }}>
                  <FormGroup aria-label="position" row>
                    <FormControlLabel
                      className="time-picker"
                      value="top"
                      control={
                        <Switch
                          color="primary"
                          checked={showTime}
                          sx={{ marginTop: "-11px" }}
                        />
                      }
                      label="Time"
                      labelPlacement="top"
                      onChange={handleToggleTime}
                    />
                  </FormGroup>
                  <TimeDatePicker
                    time={showTime}
                    startDateReFormat={startDateReFormat}
                    endDateReFormat={endDateReFormat}
                    handleStartDate={handleStartDate}
                    handleEndDate={handleEndDate}
                    Start_Date_lable={"Test Start Date"}
                    end_Date_lable={"Test End Date"}
                  />
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button className="temp-btn">
                    Temperature : {temperatureValue}°C
                  </button>
                  <button className="temp-btn">
                    Humidity : {humidityValue}
                  </button>
                </div>
                <div>
                  <IconButton
                    onClick={() => setIsFloorPlanZoomed(true)}
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "lightgray",
                      },
                      zIndex: 100, // Ensure button is clickable
                    }}
                  >
                    <ZoomInIcon />
                  </IconButton>
                </div>
              </Box>
              {/* Zoom In Button */}

              <FloorPlan mergedArray={mergedArray} />
            </Box>
            <Box className="daily-scan">
              <div className="daily-scan-content">
                <ProcessParameters
                  mergedArray={mergedArray}
                  startDateData={startDateData}
                  endDateData={endDateData}
                />
              </div>
            </Box>
          </Grid>

          {/* Right Section - Charts */}
          <Grid item xs={12} md={3}>
            <Box className="right-section">
              <Box className="insight-box">
                <div className="insights-slider-container">
                  <h3 className="insights-title">
                    Visual Inspection (Defects)
                  </h3>
                  <p className="mb-0">
                    {formatTestName(qualityVisualProduction[0]?.TestName)} -{" "}
                    {qualityVisualProduction[0]?.keyValue?.field_count}{" "} (
                    {qualityVisualProduction[0]?.keyValue?.percent_count?.toFixed(
                      2
                    )}
                    %)
                  </p>

                  <p className="mb-0">
                    {formatTestName(qualityVisualProduction[1]?.TestName)} -{" "}
                    {qualityVisualProduction[1]?.keyValue?.field_count}{" "} (
                    {qualityVisualProduction[1]?.keyValue?.percent_count.toFixed(
                      2
                    )}
                    %)
                  </p>
                  <p className="mb-0">
                    {formatTestName(qualityVisualProduction[2]?.TestName)} -{" "}
                    {qualityVisualProduction[2]?.keyValue?.field_count}{" "} (
                    {qualityVisualProduction[2]?.keyValue?.percent_count.toFixed(
                      2
                    )}
                    %)
                  </p>
                  {/* <Slider
                    {...settings}
                    dots={true}
                    customPaging={(i) => <div className="custom-dot"></div>}
                    appendDots={(dots) => (
                      <ul className="slick-dots">{dots.slice(0, 4)}</ul>
                    )}
                  >
                    {insightsData.length > 0 ? (
                      insightsData.map((e) => {
                        return <div className="insight-text">{e}</div>;
                      })
                    ) : (
                      <div className="insight-text"></div>
                    )}
                  </Slider> */}
                </div>
              </Box>
              <Divider />
              <Box className="counterfeit-location-container">
                <Box className="counterfeit-location-box">
                  <div className="insights-header counterfeit-location-header">
                    <div className="header-text">SFG Status</div>
                    <select
                      className="sfg-dropdown"
                      value={selectedSFGType} // Bind value to state
                      onChange={handleSFGTypeChange} // Attach handler
                    >
                      <option value="class">Class</option>
                      <option value="size">Size</option>
                      <option value="gloves_type">Type</option>
                    </select>
                  </div>

                  <div className="counterfeit-location-content">
                    {/* Pass the selectedSFGType to SFGBarChart if needed for internal logic */}
                    <SFGBarChart
                      sfgStatusData={sfgStatusData}
                      selectedSFGType={selectedSFGType}
                    />
                  </div>
                </Box>
              </Box>
              <Box className="cross-selling-container">
                <Box className="cross-selling-box">
                  <div className="insights-header cross-selling-header">
                    <div className="header-text">Dispatch Status</div>
                  </div>
                  <div
                    className="cross-selling-content"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    {/* Left Boxes */}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      {dispatchStatusData.slice(0, 3).map((item, index) => {
                        const backgroundColor = getChartColor(item.class_name);
                        return (
                          <Card
                            key={index}
                            sx={{
                              width: 113, // Adjust width as needed
                              height: 60, // Adjust height as needed
                              color: "black",
                              display: "flex",
                              boxShadow: "none",
                              flexDirection: "column",
                              justifyContent: "center",
                              border: `5px solid ${backgroundColor}`,
                              borderRadius: 2,
                              alignItems: "center",
                              padding: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "12px" }}
                            >
                              Class {item.class_name} :{" "}
                              {totalDispatchedCountForBoxes
                                ? (
                                    (item.dispatched_count /
                                      totalDispatchedCountForBoxes) *
                                    100
                                  ).toFixed(0)
                                : 0}
                              %
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold" }}
                            >
                              {item.dispatched_count}
                            </Typography>
                          </Card>
                        );
                      })}
                    </Box>

                    {/* DispatchStatus Chart */}
                    <DispatchStatus dispatchData={dispatchStatusData} />

                    {/* Right Boxes */}
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      {dispatchStatusData.slice(3, 6).map((item, index) => {
                        const backgroundColor = getChartColor(item.class_name);
                        return (
                          <Card
                            key={index}
                            sx={{
                              width: 113, // Adjust width as needed
                              height: 60, // Adjust height as needed
                              boxShadow: "none",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              border: `5px solid ${backgroundColor}`,
                              alignItems: "center",
                              padding: 1,
                              borderRadius: 2,
                              color: "black",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "12px" }}
                            >
                              Class {item.class_name} :{" "}
                              {totalDispatchedCountForBoxes
                                ? (
                                    (item.dispatched_count /
                                      totalDispatchedCountForBoxes) *
                                    100
                                  ).toFixed(0)
                                : 0}
                              %
                            </Typography>
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold" }}
                            >
                              {item.dispatched_count}
                            </Typography>
                          </Card>
                        );
                      })}
                    </Box>
                  </div>
                </Box>
              </Box>
              <Box className="devices-container">
                <Box className="devices-box">
                  <div className="insights-header devices-header">
                    <div className="header-text">
                      Average Time For Production
                    </div>
                  </div>
                  <div className="devices-content">
                    <AverageTime averageTimeData={averageProcessingTimeData} />
                  </div>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default TunnelOven;
